import React from "react";
import APP_CONF from "../app.conf";
import contextProvider from "../contextProvider";
import { matchPath, Redirect, Switch, Route, Prompt } from "react-router-dom";

import { _LoadingWrapper } from "../_L0_components/Widgets/_LoadingKit";
import _LayoutPage from "../_L0_components/Layout/_LayoutPage";
import _LayoutHeader from "../_L0_components/Layout/_LayoutHeader";
import _LayoutSidebar from "../_L0_components/Layout/_LayoutSidebar";
import _LayoutBody from "../_L0_components/Layout/_LayoutBody";
import _LayoutFixedBody from "../_L0_components/Layout/_LayoutFixedBody";
import _NavigationMenu from "../_L0_components/Layout/_NavigationMenu";

import _AuthenticationHandler from "./Utilities/_AuthenticationHandler";
import _ActionsShelfService from "./Services/_ActionsShelfService";
import _ApiStoreService from "./Services/_ApiStoreService";
import _TextsStoreService from "./Services/_TextsStoreService";
// import _ImagesStoreService from "./Services/_ImagesStoreService";

import _AnchorPoint from "../_L0_components/Layout/_AnchorPoint";
import Header from "../_L1_components/Layout/Header";
import Section from "../_L1_components/Layout/Section";
import Sidebar from "../_L1_components/Layout/Sidebar";
import ReactOTextCell from "../_L1_components/Elements/ReactOTextCell";
import ReactOButton from "../_L1_components/Elements/ReactOButton";

const $ = window.jQuery;
class _ReactOApp extends React.Component {
  constructor(props, initState) {
    super(props);
    this.state = {
      app_ready: false,
      system_ready: false,
      scroll_position: window.scrollY,
      texts_store_loading: true,
      images_store_loading: true,
      urlParams: "",
      ...(initState ? initState : {}),
    };
    this._CMP_CLASS = {
      "cmp._AnchorPoint": _AnchorPoint,
      "cmp.Header": Header,
      "cmp.Sidebar": Sidebar,
      "cmp.Section": Section,
      "cmp.ReactOTextCell": ReactOTextCell,
      "cmp.ReactOButton": ReactOButton,
    };

    this._CONTEXTS = {};
    this._PROMPTS = [];
    this.APP_CONF = APP_CONF;

    this.actionsShelfService = new _ActionsShelfService();

    this.apiStoreService = new _ApiStoreService({
      serverUrl: APP_CONF.SERVER_URL,
      apiPath: APP_CONF.API_PATH,
      appContext: this.getChildContext().app,
    });

    this.setState({ count: 1 });

    this.authHandler = new _AuthenticationHandler({
      apiStoreService: this.apiStoreService,
      actionsShelfService: this.actionsShelfService,
      onCheckAuth: (accountData) => {
        if (accountData.static) {
          this.redirectTo("/static");
        }
      },
      onLoginSuccess: (accountData) => {
        if (
          accountData.show_map == "no" &&
          this.getChildContext()
            .app.getLocalStorageService()
            .get("dashboard_view_mode") == "map"
        ) {
          this.getChildContext()
            .app.getLocalStorageService()
            .set("dashboard_view_mode", "card");
        }
        this.setState({
          accountData: accountData,
        });
      },
      onLogoutSuccess: () => {
        if (
          this.getChildContext().app.isCloud() &&
          this.getChildContext().app.authHandler.getAccountData().alias == "yes"
        ) {
          window.location.href = "https://wifiprobe.inrete.it/FCA/logout";
        } else {
          this.redirectTo("/login");
        }
      },
    });

    this.apiStoreService.setAuthHandler(this.authHandler);

    this.textsStoreService = new _TextsStoreService({
      apiStoreService: this.apiStoreService,
      onLoaded: (data) => {
        this.setState({
          texts_store_loading: false,
          texts: data,
        });
      },
    });

    // TODO: FIX Warning: Can't call setState on a component that is not yet mounted.
    // This is a no-op, but it might indicate a bug in your application.
    // Instead, assign to `this.state` directly or define a `state = {};`
    // class property with the desired state in the App component.
    // this.imagesStoreService = new _ImagesStoreService({
    //   apiStoreService: this.apiStoreService,
    //   imagesCluster: this.APP_CONF.PUBLIC_PATH + "/images",
    //   onLoaded: () => {
    //     this.setState({
    //       images_store_loading: false,
    //     });
    //   },
    // });

    this._getContext = this._getContext.bind(this);
    this._registerContext = this._registerContext.bind(this);
    this._unregisterContext = this._unregisterContext.bind(this);
    this.redirectTo = this.redirectTo.bind(this);
    this.defineRedirectionPrompter = this.defineRedirectionPrompter.bind(this);
    this.checkRedirectionPrompts = this.checkRedirectionPrompts.bind(this);
  }

  componentDidCatch(error, info) {
    // console.log("REACTO BASE APP componentDidCatch");
    // console.log(error);
    // console.log(info);
    if (this.onComponentDidCatch) {
      this.onComponentDidCatch(error, info);
    }
  }

  defineRedirectionPrompter(action) {
    this._PROMPTS.push(action);
  }

  checkRedirectionPrompts(location, action) {
    if (this._PROMPTS.length > 0) {
      let _prompts_ok = 0;
      this._PROMPTS.forEach((_CURR_prompt, _CURR_idx) => {
        let _TMP = _CURR_prompt(() => {
          this.redirectTo(location);
        });
        _prompts_ok = _TMP ? _prompts_ok + 1 : _prompts_ok;
      });
      if (_prompts_ok == this._PROMPTS.length) {
        return true;
      } else {
        return false;
      }
    } else {
      return true;
    }
  }

  // Redirector
  redirectTo(to, do_replace) {
    // console.log("DEBUG :: _ReactOApp -> redirectTo", this.state.urlParams);
    let routePrefixMatch = null;
    if (this._ROUTE_PREFIX) {
      routePrefixMatch = matchPath(this.props.location.pathname, {
        path: this._ROUTE_PREFIX,
      });
      // console.log("routePrefixMatch ", routePrefixMatch);
    }
    if (to == "_HOME_") {
      to =
        (!this.getChildContext().app.isCloud() && "/edge/active") ||
        this.ROUTES.home.pathname + this.state.urlParams ||
        (this.ROUTES.home.search ? this.ROUTES.home.search : null);
      // console.log(
      //   this.ROUTES.home.pathname +
      //     (this.ROUTES.home.search ? this.ROUTES.home.search : null)
      // );
    }
    // console.warn(
    //   "Redirecting to " + routePrefixMatch
    //     ? "/" + routePrefixMatch.params.webtoken + to
    //     : to
    // );
    if (do_replace) {
      this.props.history.replace(
        routePrefixMatch ? "/" + routePrefixMatch.params.webtoken + to : to
      );
    } else {
      this.props.history.push(
        routePrefixMatch ? "/" + routePrefixMatch.params.webtoken + to : to
      );
    }
  }

  // Context sharing service
  _makeid() {
    var text = "";
    var possible =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    for (var i = 0; i < 5; i++)
      text += possible.charAt(Math.floor(Math.random() * possible.length));
    return text;
  }

  setUrlParams(params) {
    this.setState({ urlParams: params });
  }

  getRangeColor(type, val, success) {
    let defaultClassName = "";
    if (success) defaultClassName = "text-success";
    switch (type) {
      case "overlap":
        if (val > 4 && val < 9) return "text-orange";
        if (val > 9) return "text-danger";
        return defaultClassName;
      case "rssi":
        if (val >= -74 && val < -60 && val != 0) return "text-orange";
        if (val < -74 && val != 0) return "text-danger";
        return defaultClassName;
      default:
        return defaultClassName;
    }
  }

  // getUrlParams() {
  //   // const urlParams = new URLSearchParams(window.location.search);
  //   // const params = Array.from(urlParams.keys());
  //   let search = "?view";
  //   if (this.state.urlParams && this.state.urlParams != "") {
  //     search = window.location.search;
  //   }
  //   return search;
  // }

  _registerContext(context_ref, ctx) {
    var new_id = this._makeid();
    this._CONTEXTS[context_ref + "___" + new_id] = ctx[Object.keys(ctx)[0]];
    return context_ref + "___" + new_id;
  }

  _unregisterContext(context_ref) {
    delete this._CONTEXTS[context_ref];
  }

  _getContext(context_ref) {
    var found_context_ref = null;
    Object.keys(this._CONTEXTS).forEach((entry, idx) => {
      var re = new RegExp(context_ref + "___.*$", "g");
      if (re.test(entry)) {
        found_context_ref = entry;
        return false;
      }
    });
    return this._CONTEXTS[found_context_ref];
  }

  _validatePath(path) {
    return (
      (this._PREFIX_ROUTE_DATA
        ? "/" + this._PREFIX_ROUTE_DATA.match.params.webtoken
        : "") + path
    );
  }

  setPostLoginRedirect(to) {
    this._POST_LOGIN_REDIRECT_TO = to;
  }

  getPostLoginRedirect() {
    return this._POST_LOGIN_REDIRECT_TO;
  }

  // App context retrieving
  getChildContext() {
    return {
      app: {
        jQuery: $,
        conf: this.APP_CONF,
        redirectTo: this.redirectTo.bind(this),
        makeId: this._makeid.bind(this),
        getRangeColor: this.getRangeColor.bind(this),
        setPostLoginRedirect: this.setPostLoginRedirect.bind(this),
        getPostLoginRedirect: this.getPostLoginRedirect.bind(this),
        getUrlParams: this.state.urlParams,
        setUrlParams: this.setUrlParams.bind(this),
        getDiag: this.getDiag.bind(this),
        getErrWording: this.getErrWording.bind(this),
        registerContext: this._registerContext,
        unregisterContext: this._unregisterContext,
        getContext: this._getContext,
        app_ready: this.state.app_ready,
        urlParams: this.state.urlParams,
        system_ready: this.state.system_ready,
        scroll_position: this.state.scroll_position,
        activeRouteData: this._ACTIVE_ROUTE_DATA,
        prefixRouteData: this._PREFIX_ROUTE_DATA,
        loginRoute: this.ROUTES ? this.ROUTES.login || "/" : "/",
        homeRoute: this.ROUTES ? this.ROUTES.home || "/" : "/",
        defineRedirectionPrompter: this.defineRedirectionPrompter,

        getApiStoreService: () => {
          return this.apiStoreService;
        },
        getActionsShelfService: () => {
          return this.actionsShelfService;
        },
        getTextsStoreService: () => {
          return this.textsStoreService;
        },
        getImagesStoreService: () => {
          return this.imagesStoreService;
        },
        //	getRequestHandler: () => {return this.requestHandler},
        getLocalStorageService: () => {
          return window.$.localStorage;
        },

        isBrowserEdge: () => {
          if (document.documentMode || /Edge/.test(navigator.userAgent)) {
            return true;
          } else {
            return false;
          }
        },
        isBrowserIE11: () => {
          if (
            /(?:\b(MS)?IE\s+|\bTrident\/7\.0;.*\s+rv:)(\d+)/.test(
              navigator.userAgent
            )
          ) {
            return true;
          } else {
            return false;
          }
        },
        isBrowserFirefox: () => {
          if (/Firefox/.test(navigator.userAgent)) {
            return true;
          } else {
            return false;
          }
        },

        authHandler: this.authHandler,

        validatePath: this._validatePath.bind(this),

        colors: APP_CONF.APP_COLORS,
        router: {
          location: this.props.location,
          history: this.props.history,
          match: this.props.match,
          getLastLocation: () => {
            return this._LAST_LOCATION;
          },
        },
        iterateChildren: this.iterateChildren,
        ...(this.onGetChildContext ? this.onGetChildContext() : {}),
      },
    };
  }

  extractConsideration(consideration) {
    let extra = "";
    let c = consideration.split(",");
    let match = c.find((s) => s.includes("RECOVER"));
    if (match) {
      let cut = match.slice(8);
      let elem = cut.split("_");
      if (elem.length == 3) {
        const diag = elem[0];
        const diag2 = elem[1] == "MO" ? "mostly on" : "on";
        extra = `from ${this.getDiag(diag)} ${diag2} ${elem[2]}`;
      }
    }
    return extra;
  }

  getDiag(diag, consideration) {
    let { text } = this.APP_CONF.MLY_STATES_DICTIONARY[diag] || {};
    if (diag == "R" && consideration) {
      return `${text} ${this.extractConsideration(consideration)}`;
    } else {
      return text;
    }
  }

  getErrWording(err) {
    const prefix = err.substring(0, 2);
    const error = err.substring(3, err.length);
    let wording = "";
    if (prefix == "MO") {
      wording = " mostly on " + error;
      if (error == "DISCEARLY") {
        wording = " mostly for AP Drop";
      }
    } else {
      wording = " on  " + error;
      if (error == "DISCEARLY") {
        wording = " for AP Drop";
      }
    }
    return wording;
  }

  iterateChildren(children, with_props) {
    //	console.log("DEBUG :: _ReactOApp _ iterateChildren");
    return children.map((_C_entry, _C_idx) => {
      let _TMP_cmp = null;
      if (_C_entry.component) {
        if (
          /^cmp\./.test(_C_entry.component) &&
          this._CMP_CLASS[_C_entry.component]
        ) {
          _TMP_cmp = this._CMP_CLASS[_C_entry.component];
        } else {
          _TMP_cmp = _C_entry.component;
        }
      }
      return _TMP_cmp ? (
        <_TMP_cmp
          key={_C_idx}
          {..._C_entry.props}
          {...(with_props ? with_props : {})}
          children={
            _C_entry.children
              ? this.iterateChildren(_C_entry.children, with_props)
              : null
          }
        />
      ) : (
        <span key={_C_idx}>{_C_entry}</span>
      );
    });
  }

  /////////////////////////
  //	Lifecycle methods
  //

  componentDidMount() {
    // console.log("DEBUG :: _ReactOApp -> componentDidMount");
    if (window.location.search != "") {
      this.setUrlParams(window.location.search);
    }
    let continuous = false;
    window.addEventListener("scroll", (ev) => {
      if (
        ((continuous ? true : this.state.scroll_position >= 40) &&
          ev.target.scrollingElement.scrollTop < 40) ||
        (this.state.scroll_position <= 40 &&
          ev.target.scrollingElement.scrollTop > 40)
      ) {
        this.setState({
          scroll_position: ev.target.scrollingElement.scrollTop,
        });
      }
    });
    this.setState(
      {
        system_ready: true,
      },
      () => {
        if (this.onComponentDidMount) this.onComponentDidMount();
      }
    );
  }

  componentWillUnmount() {
    //	console.log("DEBUG :: _ReactOApp -> componentWillUnmount");
    if (this.onComponentWillUnmount) this.onComponentWillUnmount();
  }

  shouldComponentUpdate(nextProps) {
    // console.log("DEBUG :: _ReactOApp -> shouldComponentUpdate", this._PREFIX_ROUTE_DATA);
    if (this._PREFIX_ROUTE_DATA && this._PREFIX_ROUTE_DATA.match) {
      let _REG = new RegExp(
        "^/" + this._PREFIX_ROUTE_DATA.match.params.webtoken
      );
      if (_REG.exec(nextProps.location.pathname)) {
        return true;
      } else {
        console.warn(
          "Incorrect prefix path, replacing with: /" +
            this._PREFIX_ROUTE_DATA.match.params.webtoken +
            nextProps.location.pathname +
            nextProps.location.hash
        );
        this.redirectTo(
          "/" +
            this._PREFIX_ROUTE_DATA.match.params.webtoken +
            nextProps.location.pathname +
            nextProps.location.hash
        );
        // return <Redirect to={"/" +
        // this._PREFIX_ROUTE_DATA.match.params.webtoken +
        // nextProps.location.pathname +
        // nextProps.location.hash} />;
        return false;
      }
    } else {
      return true;
    }
  }

  render() {
    // console.log("DEBUG :: _ReactOApp -> render", this.state);

    let routePrefixMatch = null;
    if (this._ROUTE_PREFIX) {
      routePrefixMatch = matchPath(this.props.location.pathname, {
        path: this._ROUTE_PREFIX,
      });
    }
    this._PREFIX_ROUTE_DATA = routePrefixMatch
      ? {
          match: routePrefixMatch,
        }
      : null;

    this._LAST_LOCATION = this._ACTIVE_ROUTE_DATA
      ? this._ACTIVE_ROUTE_DATA.location.pathname
      : null;
    let activeRouteData = null;

    if (this.ROUTES) {
      Object.keys(this.ROUTES.reserved).forEach((_C_path, _C_idx) => {
        const match = matchPath(this.props.location.pathname, {
          path: (this._ROUTE_PREFIX || "") + _C_path,
          exact: this.ROUTES.reserved[_C_path].exact,
          strict: this.ROUTES.reserved[_C_path].strict,
        });
        if (match && match.params.status) {
          this.getChildContext()
            .app.getLocalStorageService()
            .set("nav_position", match.params.status);
        }
        if (match) {
          activeRouteData =
            this.ROUTES.reserved[
              routePrefixMatch
                ? match.path.replace(routePrefixMatch.path, "")
                : match.path
            ];
          activeRouteData.isReserved = true;
          activeRouteData.match = match;
          activeRouteData.match.params = {
            ...activeRouteData.match.params,
            ...(routePrefixMatch ? routePrefixMatch.params : {}),
          };
          return;
        }
      });
      if (!activeRouteData) {
        Object.keys(this.ROUTES.public).forEach((_C_path, _C_idx) => {
          const match = matchPath(this.props.location.pathname, {
            path: (this._ROUTE_PREFIX || "") + _C_path,
            exact: this.ROUTES.public[_C_path].exact,
            strict: this.ROUTES.public[_C_path].strict,
          });
          if (match) {
            activeRouteData =
              this.ROUTES.public[
                routePrefixMatch
                  ? match.path.replace(routePrefixMatch.path, "")
                  : match.path
              ];
            activeRouteData.match = match;
            activeRouteData.match.params = {
              ...activeRouteData.match.params,
              ...(routePrefixMatch ? routePrefixMatch.params : {}),
            };
            return;
          }
        });
      }

      if (activeRouteData) {
        if (activeRouteData.nav_position != "dynamic") {
          // console.log("active", activeRouteData);
          this.getChildContext()
            .app.getLocalStorageService()
            .set("nav_position", activeRouteData.nav_position);

          if (
            activeRouteData.nav_position == "setup" &&
            activeRouteData.subroutes
          ) {
            const match = Object.keys(activeRouteData.subroutes).find((path) =>
              matchPath(this.props.location.pathname, { path })
            );
            if (match) {
              this.getChildContext()
                .app.getLocalStorageService()
                .set(
                  "setup_position",
                  activeRouteData.subroutes[match].setup_position
                );
            }
          }
        }
        activeRouteData.location = this.props.location;
        this._ACTIVE_ROUTE_DATA = activeRouteData;
        if (this.state.system_ready && this.state.app_ready) {
          if (activeRouteData.isReserved && !this.authHandler.isAuthorized()) {
            // this.redirectTo(this.ROUTES.login);
            return <Redirect to={this.ROUTES.login} />;
          } else if (
            activeRouteData.privileges == "ADMIN" &&
            this.state.accountData.type != "ADMIN"
          ) {
            // this.redirectTo(this.ROUTES.home);
            return <Redirect to={this.ROUTES.home} />;
          }
        }

        //				console.log("FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFF");
        //				console.log(this._ACTIVE_ROUTE_DATA.sidebarMenu);

        this._ACTIVE_ROUTE_DATA._COMPILED_sidebarMenu = undefined;
        if (
          this._ACTIVE_ROUTE_DATA.sidebarMenu &&
          this._ACTIVE_ROUTE_DATA.layoutType == "page-admin"
        ) {
          let _stringified_menu = JSON.stringify(
            this._ACTIVE_ROUTE_DATA.sidebarMenu
          );
          //					console.log("STRINGY: " + _stringified_menu);

          let re = RegExp("___-(.[^-]*)-___", "g");
          let match = true;
          while (match) {
            match = re.exec(_stringified_menu);
            //						console.log("MATCH:");
            //						console.log(match);
            if (match) {
              let matchedRouteParam =
                this._ACTIVE_ROUTE_DATA.match.params[match[1]];
              if (matchedRouteParam) {
                _stringified_menu = _stringified_menu.replace(
                  new RegExp(match[0], "g"),
                  matchedRouteParam
                );
              } else {
                console.error(
                  " :: Sidebar _ render [MISSING MATCHING ROUTE PARAM WHILE FORMATTING PATH] -- needed: "
                );
                console.error(match[1]);
              }
            }
          }

          //					console.log("STRINGY OUT: " + _stringified_menu);
          this._ACTIVE_ROUTE_DATA._COMPILED_sidebarMenu =
            JSON.parse(_stringified_menu);

          this._ACTIVE_ROUTE_DATA.sidebarMenu.items.forEach(
            (_C_item, _C_idx1) => {
              Object.keys(_C_item).forEach((_C_entry, _C_idx2) => {
                if (typeof _C_item[_C_entry] == "function") {
                  this._ACTIVE_ROUTE_DATA._COMPILED_sidebarMenu.items[_C_idx1][
                    _C_entry
                  ] = _C_item[_C_entry];
                }
              });
            }
          );

          if (
            this._ACTIVE_ROUTE_DATA.sidebarMenu.title &&
            this._ACTIVE_ROUTE_DATA.sidebarMenu.title.output
          ) {
            this._ACTIVE_ROUTE_DATA._COMPILED_sidebarMenu.title.output =
              this._ACTIVE_ROUTE_DATA.sidebarMenu.title.output;
          }
        }
      } else {
        console.warn(routePrefixMatch ? "OK" : "KO");
        console.warn("NO ACTIVE ROUTE");
        // this.redirectTo(this.ROUTES.home);
        return <Redirect to={this.ROUTES.home} />;
      }
    }

    return (
      <span>
        <Prompt
          key="1"
          when={true}
          message={(location, action) => {
            return this.checkRedirectionPrompts(location, action);
          }}
        />
        <_LoadingWrapper
          loadingPlug={!this.state.system_ready || !this.state.app_ready}
          hideOnLoading={true}
          fullscreen={true}
        >
          {this.state.system_ready &&
          this.state.app_ready &&
          (!activeRouteData.isReserved ||
            (activeRouteData.isReserved && this.authHandler.isAuthorized()))
            ? this.onRender(
                this.ROUTES ? (
                  <_LayoutPage
                    className="_base"
                    backgroundImage={this.ROUTES.pageBackground}
                    backgroundColor={this.ROUTES.pageColor}
                  >
                    {this._ACTIVE_ROUTE_DATA.layoutType == "page" ||
                    this._ACTIVE_ROUTE_DATA.layoutType == "page-admin" ? (
                      <_LayoutHeader
                        positionFixed={false}
                        shareContextWithName="context__header"
                      >
                        {/(?:\b(MS)?IE\s+|\bTrident\/7\.0;.*\s+rv:)(\d+)/.test(
                          navigator.userAgent
                        ) ? (
                          <div className="bg-warning text-center py-2">
                            This browser is not supported by this web
                            application. Please use a modern browser like
                            Chrome, Safari, Firefox or Microsoft Edge for a
                            better experience
                          </div>
                        ) : null}
                        <Header>
                          <_NavigationMenu
                            className={"navbar-nav nav-left"}
                            menu={
                              this._ACTIVE_ROUTE_DATA?.leftHeaderMenu?.filter(
                                (elem) => {
                                  if (
                                    elem.cloud &&
                                    this.getChildContext().app.isCloud()
                                  ) {
                                    return elem;
                                  } else {
                                    return false;
                                  }
                                }
                              ) || []
                            }
                          />
                          <_NavigationMenu
                            className={"navbar-nav nav-right"}
                            menu={this._ACTIVE_ROUTE_DATA.rightHeaderMenu}
                            user={this.state?.accountData?.user || "-"}
                          />
                        </Header>
                      </_LayoutHeader>
                    ) : null}

                    <_LayoutSidebar
                      visible={
                        this._ACTIVE_ROUTE_DATA.layoutType == "page" ||
                        this._ACTIVE_ROUTE_DATA.layoutType == "page-admin"
                      }
                      forceClosed={
                        !(this._ACTIVE_ROUTE_DATA.layoutType == "page-admin")
                      }
                      shareContextWithName="context__sidebar"
                    >
                      <Sidebar>
                        {this._ACTIVE_ROUTE_DATA.layoutType == "page-admin" ? (
                          <_NavigationMenu
                            className={"navbar-nav nav-left"}
                            menu={this._ACTIVE_ROUTE_DATA._COMPILED_sidebarMenu}
                            sidebar
                            location={this.props?.location?.pathname || ""}
                          />
                        ) : null}
                      </Sidebar>
                    </_LayoutSidebar>

                    <_LayoutBody>
                      <Switch>
                        {Object.keys(this.ROUTES.reserved).map(
                          (_C_routePath, _C_idx) => {
                            let routeData = this.ROUTES.reserved[_C_routePath];
                            var CMP = { component: routeData.component };
                            if (routeData.component instanceof Array) {
                              CMP = {
                                render: () => {
                                  return this.iterateChildren(
                                    routeData.component
                                  );
                                },
                              };
                            }
                            return (
                              <Route
                                key={_C_idx}
                                path={(this._ROUTE_PREFIX || "") + _C_routePath}
                                exact={routeData.exact}
                                {...CMP}
                              />
                            );
                          }
                        )}

                        {Object.keys(this.ROUTES.public).map(
                          (_C_routePath, _C_idx) => {
                            let routeData = this.ROUTES.public[_C_routePath];
                            var CMP = { component: routeData.component };
                            if (routeData.component instanceof Array) {
                              CMP = {
                                render: () => {
                                  return this.iterateChildren(
                                    routeData.component
                                  );
                                },
                              };
                            }
                            return (
                              <Route
                                key={_C_idx}
                                path={(this._ROUTE_PREFIX || "") + _C_routePath}
                                exact={routeData.exact}
                                {...CMP}
                              />
                            );
                          }
                        )}

                        <Redirect to={this.ROUTES.home} />
                      </Switch>
                    </_LayoutBody>
                    {this.ROUTES.fixed ? (
                      <_LayoutFixedBody>
                        <this.ROUTES.fixed />
                      </_LayoutFixedBody>
                    ) : null}
                  </_LayoutPage>
                ) : null
              )
            : null}
        </_LoadingWrapper>
      </span>
    );
  }
}

export default contextProvider(_ReactOApp, {
  define: ["app"],
});
